import { useCallback, useRef } from "react";

interface Props {
  onResize: (delta: number) => void;
  onResizeEnd?: () => void;
}

export default function ResizableDivider({ onResize, onResizeEnd }: Props) {
  const dragging = useRef(false);
  const lastX = useRef(0);

  const onMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      dragging.current = true;
      lastX.current = e.clientX;

      const onMouseMove = (ev: MouseEvent) => {
        if (!dragging.current) return;
        const delta = ev.clientX - lastX.current;
        lastX.current = ev.clientX;
        onResize(delta);
      };

      const onMouseUp = () => {
        dragging.current = false;
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
        onResizeEnd?.();
      };

      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
    },
    [onResize, onResizeEnd],
  );

  return (
    <div
      onMouseDown={onMouseDown}
      style={{
        width: 5,
        flexShrink: 0,
        cursor: "col-resize",
        background: "transparent",
        borderRight: "1px solid #DEE3EA",
        transition: "background 0.15s",
        position: "relative",
        zIndex: 1,
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLDivElement).style.background =
          "rgba(0,157,224,0.25)";
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLDivElement).style.background = "transparent";
      }}
    />
  );
}
